enum RelationStatuses {
  Draft = "Draft",
  Pending = "Pending",
  Accepted = "Accepted",
  Rejected = "Rejected",
  Blocked = "Blocked",
  Deleted = "Deleted"
}

export default RelationStatuses;
